import { render, staticRenderFns } from "./BaseForm.vue?vue&type=template&id=85b361de"
import script from "./BaseForm.vue?vue&type=script&lang=ts"
export * from "./BaseForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports